import type { PropsWithChildren, ReactNode } from "react";
import { cn } from "@/lib/cn";

interface CardProps extends PropsWithChildren {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}

export function Card({ children, title, subtitle, action, className }: CardProps) {
  return (
    <section className={cn("panel-surface p-6", className)}>
      {(title || subtitle || action) && (
        <header className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="space-y-1">
            {title && <h2 className="text-xl">{title}</h2>}
            {subtitle && <p className="text-sm text-mist">{subtitle}</p>}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
